<template>
    <inertia-link :href="route('vehicle.vehicle', { vehicle: vehicle.id })">
        <div
            class="
                group
                mb-8
                cursor-pointer
                w-64
                bg-white
                overflow-hidden
                shadow-lg
                rounded-xl
            "
        >
            <div class="relative overflow-hidden h-52" v-if="!hidePhoto">
                <img :src="vehicle.photo" class="photo" />

                <div class="absolute bottom-2 w-full flex justify-center">
                    <span
                        class="
                            bg-primary
                            rounded-full
                            text-white text-xs
                            py-1
                            px-6
                            tracking-wider
                            group-hover:bg-secondary
                            transition-all
                            duration-500
                        "
                    >
                        More Information
                    </span>
                </div>
            </div>

            <div class="p-4 flex flex-col h-32">
                <div class="flex justify-between text-primary font-bold">
                    <!-- vehicle name -->
                    <div class="text-secondary font-medium">
                        {{ vehicleName }}
                    </div>

                    <!-- reserve -->
                    <div v-if="vehicle.usd_reserve !== null" class="pl-2">
                        ${{ formatNumber(vehicle.usd_reserve) }}
                    </div>
                </div>

                <!-- trim -->
                <div class="flex-grow text-sm text-secondary font-light">
                    {{ vehicle.trim }}
                </div>

                <!-- mileage -->
                <div
                    class="flex-shrink text-xs text-secondary-light font-light"
                >
                    <span v-if="vehicle.engine">
                        {{ vehicle.engine }}
                    </span>
                    <span class="mx-2" v-if="vehicle.engine && vehicle.miles">
                        |
                    </span>
                    <span v-if="vehicle.miles">
                        {{ formatNumber(vehicle.miles) }} mi
                    </span>
                </div>
            </div>

            <div class="w-full flex justify-center mt-2 mb-4" v-if="hidePhoto">
                <span
                    class="
                        bg-primary
                        rounded-full
                        text-white text-xs
                        py-1
                        px-6
                        tracking-wider
                        group-hover:bg-secondary
                        transition-all
                        duration-500
                    "
                >
                    More Information
                </span>
            </div>
        </div>
    </inertia-link>
</template>

<style scoped>
.photo {
    clip-path: ellipse(100% 60% at 50% 40%);
}
</style>

<script>
export default {
    props: {
        vehicle: {
            type: Object,
            required: true,
        },
        hidePhoto: {
            type: Boolean,
            required: false,
        },
    },
    computed: {
        vehicleName() {
            return (
                this.vehicle.year +
                " " +
                this.vehicle.make +
                " " +
                this.vehicle.model
            );
        },
    },
    methods: {
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
};
</script>
